/**
 * WordPress dependencies
 */

/**
 * Internal dependencies.
 */
import blockJson from './block.json';

/**
 * Block constants
 */
const { name } = blockJson;

export default {
	hookPrefix: name.replace( '/', '-' ),
	layouts: [ {
		name: 'layout-1',
		label: 'Layout 1',
		imageAlign: 'center',
		titleAlign: 'center',
		ratingAlign: 'center',
	}, {
		name: 'layout-2',
		label: 'Layout 2',
		imageAlign: 'center',
		titleAlign: 'left',
		ratingAlign: 'left',
	}, {
		name: 'layout-3',
		label: 'Layout 3',
		imageAlign: 'center',
		titleAlign: 'right',
		ratingAlign: 'right',
	}, {
		name: 'layout-4',
		label: 'Layout 4',
		imageAlign: 'center',
		titleAlign: 'right',
		ratingAlign: 'right',
	}, {
		name: 'layout-5',
		label: 'Layout 5',
		imageAlign: 'center',
		titleAlign: 'right',
		ratingAlign: 'right',

	} ],
};
